import React, { Component } from 'react'
import { Provider } from 'react-redux'
import configureStore from '../configureStore'
import { Router, Route, browserHistory } from 'react-router';
import SurveyList from './SurveyList'
import Survey from './Survey'
import FourOFour from './../components/404'

const store = configureStore()

export default class Root extends Component {
  render() {
    return (
      <div>
      <Provider store={store}>
        <Router history={browserHistory} onUpdate={() => window.scrollTo(0, 0)}>
          <Route path="/" component={SurveyList}/>
          <Route path="survey/:id" component={Survey}/>
          <Route path='*' component={FourOFour} />
        </Router>
      </Provider>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Root.js